module.exports = __webpack_public_path__ + "img/armor-king.b8d7c041.jpg";